import React from 'react';

// Logo variants:
// - icon: Standalone icon (works on any background)
// - color-light: Color logo for light backgrounds (Plexata 1)
// - color-dark: Color logo for dark backgrounds (Plexata 2)
// - white: All-white logo (Plexata 3)
// - black: All-black logo (Plexata 4)

export const PlexataLogo = ({ variant = 'color-light', className = '', height = 32 }) => {
  const logos = {
    'icon': '/plexata-icon.png',
    'color-light': '/plexata-logo-light-bg.png',
    'color-dark': '/plexata-logo-dark-bg.png',
    'white': '/plexata-logo-white.png',
    'black': '/plexata-logo-black.png',
  };

  return (
    <img 
      src={logos[variant]} 
      alt="Plexata" 
      className={className}
      style={{ height: `${height}px`, width: 'auto' }}
    />
  );
};

export const PlexataIcon = ({ className = '', size = 32 }) => {
  return (
    <img 
      src="/plexata-icon.png" 
      alt="Plexata" 
      className={className}
      style={{ height: `${size}px`, width: `${size}px` }}
    />
  );
};

export default PlexataLogo;
